import { type CardIdType } from '@/defs/card'
import { type ClipboardCardType } from '@/defs/clipboard'

const LEGACY_KEY = 'persist:root'

const parseCard = (cardId: string, isCommander?: true): ClipboardCardType => ({
  cardId: cardId as CardIdType,
  ...(isCommander && { isCommander }),
})

const parseSlug = (value: unknown) =>
  value && typeof value === 'object' && 'url' in value ? String(value.url) : String(value || '')

export const prodToV1 = (): ClipboardCardType[] | undefined => {
  if (typeof window === 'undefined') return undefined

  try {
    const root = window.localStorage.getItem(LEGACY_KEY)
    if (!root) return undefined

    const clipboard = JSON.parse(JSON.parse(root).clipboard || 'null')
    if (!clipboard) return undefined

    const { cards = {}, commander, commanders } = clipboard

    const commanderSlugs: string[] = (Array.isArray(commanders) ? commanders : commander ? [commander] : []).map(
      parseSlug,
    )

    const slugs = Object.keys(cards as Record<string, unknown>)

    const commanderSet = new Set(commanderSlugs.filter(Boolean))
    const migrated = [
      ...commanderSlugs.filter(Boolean).map((slug) => parseCard(slug, true)),
      ...slugs.filter((slug) => slug && !commanderSet.has(slug)).map((slug) => parseCard(slug)),
    ]

    return migrated.length > 0 ? migrated : undefined
  } catch {
    return undefined
  }
}
